'use client';

import type { ReactNode } from 'react';

import classnames from 'classnames';
import {
  IoClose,
  IoInformationCircleOutline,
  IoWarningOutline,
} from 'react-icons/io5';

import type { BaseComponentProps } from '../../base-component.types';
import { Icon } from '../../icon';
import { IconButton } from '../../icon-button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../tooltip';

import styles from './Header.module.scss';

type ContainerProps = BaseComponentProps & {
  title?: string;
  titleIcon?: ReactNode;
  tooltip?: ReactNode;
  warning?: ReactNode;
  onClose?: () => void;
};

function Header({
  style,
  className,
  title,
  titleIcon,
  tooltip,
  warning,
  onClose,
}: ContainerProps) {
  return (
    <div style={style} className={classnames(styles['main'], className)}>
      <div className={styles['title']}>
        {titleIcon}
        {title}
      </div>
      <div className={styles['actions']}>
        {tooltip && (
          <Tooltip>
            <TooltipTrigger asChild={true}>
              <Icon
                className={styles['tooltip']}
                icon={<IoInformationCircleOutline />}
                size="sm"
              />
            </TooltipTrigger>
            <TooltipContent className={styles['tooltip-content']}>
              {tooltip}
            </TooltipContent>
          </Tooltip>
        )}
        {warning && (
          <Tooltip>
            <TooltipTrigger asChild={true}>
              <Icon
                className={classnames(styles['tooltip'], styles['warning'])}
                icon={<IoWarningOutline />}
                size="sm"
              />
            </TooltipTrigger>
            <TooltipContent className={styles['tooltip-content']}>
              {warning}
            </TooltipContent>
          </Tooltip>
        )}
        {onClose && (
          <IconButton aria-label="close" icon={<IoClose />} onClick={onClose} />
        )}
      </div>
    </div>
  );
}

export { Header };
